<div class="wrapper">
  <div class="heading">
    Delivery of {{name}}
  </div>
  <div class="content">
    <section class="section usage-section">
      <app-usage-bar
        class="usage-bar usage-today"
        heading="TODAY"
        [percent]="usedToday.percent"
        [label]="usedToday.label"
        />
      @if (data.material) {
        <app-usage-bar
          class="usage-bar usage-all-time"
          heading="ALL TIME"
          [percent]="totalUsed.percent"
          [label]="totalUsed.label"
          />
      }
    </section>
    @if (data.bid_item) {
      <section
        class="section details-section"
        >
        <div class="details-block">
          <div class="section-heading">
            BID ITEM
          </div>
          <div class="section-content">
            {{ data.bid_item?.item }} - {{data.bid_item?.description}}
          </div>
        </div>
      </section>
    }
    @if (data.comment) {
      <section
        class="section attachments-section"
        >
        <div class="section-heading">
          DESCRIPTION
        </div>
        <div class="section-content">
          {{ data.comment }}
        </div>
      </section>
    }
    <section class="section values-section">
      <app-view-field
        class="value-field"
        [label]="data.received !== null ? 'RECEIVED' : 'USED'"
        [value]="data.received !== null ? data.received : data.used"
        hint=""
        [uom]="data.material?.uom"
        />
      @for (field of fields; track field) {
        <app-view-field
          class="value-field"
          [label]="field.label"
          [value]="field.value"
          [hint]="field.hint"
          [uom]="field.uom"
          />
      }
    </section>
    @if (data.pictures?.length) {
      <section
        class="section attachments-section"
        >
        <app-attachments-block
          [pictures]="data.pictures"
          />
      </section>
    }
  </div>
</div>
